var sidebar = require( './sidebar-menu' );

var meeting_routing = ( function( $ ) {

	var $pages_wrapper,
		$pages,
		$nav;

	var _init = function() {
		$pages_wrapper = $( '#meeting-pages' );
		$pages         = $pages_wrapper.find( '.meeting-page' );
		$nav           = $( '#sidebar-menu' );

		_initial_reveal();

		$nav.find( 'li.menu-item a' ).on( 'click', _setup_nav_link );
	};

	var _highlight_active_menu = function() {
		$nav.find( 'li' ).removeClass( 'active' );

		var active_item       = $pages.filter( '.displayed' ).data( 'page' ),
			$active_menu_item = $nav.find( 'a[data-page="' + active_item + '"]' );

		$active_menu_item.closest( 'li' ).addClass( 'active' );
	};

	var _hide_pages = function () {
		$pages.css( { 'display' : 'none' } );
		$pages.removeClass( 'displayed' );

		sidebar.set_sidebar_container_height();
	};

	var _show_page = function ( $page ) {
		$page.css( { 'display' : 'block' } );
		$page.addClass( 'displayed' );

		_highlight_active_menu()
	};

	var _setup_nav_link = function( e ) {
		e.preventDefault();

		var $data_page = $( this ).data( 'page' );
		var $page      = $pages_wrapper.find( '.meeting-page[data-page="'+ $data_page +'"]' );

		// Don't do anything if already shown
		if ( $page.hasClass( 'displayed' ) ) {
			return;
		}

		window.history.replaceState( null, null, $data_page );

		_reveal_page( $page );
	};

	var _reveal_page = function ( $page ) {
		_hide_pages();
		_show_page( $page );

		sidebar.set_sidebar_container_height();
		sidebar.setup_scroll_to_fixed();
	};

	var _initial_reveal = function() {
		var url         = window.location.href;
		var hashtag_pos = url.indexOf( '#' );

		// If url doesn't contain # show first page
		if ( hashtag_pos <= 0 ) {
			// Hide all pages
			_hide_pages();

			// Show the first page
			_show_page( $pages.first() );
		} else {

			var $data_page = url.substr( hashtag_pos );
			var $page = $pages_wrapper.find( '.meeting-page[data-page="' + $data_page + '"]' );

			_reveal_page( $page );
		}
	};

	if ( $( '#meeting-pages' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = meeting_routing;